import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Star } from 'lucide-react';
import { pricing } from '../data/mock';

const Tarifs = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-blue-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            <span className="text-blue-600">Tarifs</span> transparents
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des prix compétitifs et clairs pour tous nos services professionnels
          </p>
          <p className="text-base text-gray-900 font-semibold mt-4">
            (Les prix sont indiqués en hors taxes)
          </p>
        </div>
      </section>

      {/* Pricing Tables */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {pricing.map((category, catIndex) => (
            <div key={category.id} className={catIndex > 0 ? 'mt-20' : ''}>
              <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
                {category.category}
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {category.plans.map((plan, planIndex) => {
                  const isPopular = plan.popular;
                  
                  return (
                    <div
                      key={planIndex}
                      className={`relative bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-2xl ${
                        isPopular ? 'border-4 border-blue-600 transform scale-105' : 'border-2 border-gray-200'
                      }`}
                    >
                      {isPopular && (
                        <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white text-center py-3 px-4">
                          <div className="flex items-center justify-center space-x-2">
                            <Star className="w-5 h-5 fill-current" />
                            <span className="font-bold text-sm uppercase tracking-wide">
                              Plus populaire
                            </span>
                            <Star className="w-5 h-5 fill-current" />
                          </div>
                        </div>
                      )}
                      
                      <div className="p-8">
                        <h3 className="text-2xl font-bold text-gray-900 mb-4">
                          {plan.name}
                        </h3>
                        <div className="mb-6">
                          <span className="text-4xl font-bold text-blue-600">
                            {plan.price}
                          </span>
                        </div>
                        
                        <ul className="space-y-4 mb-8">
                          {plan.features.map((feature, idx) => (
                            <li key={idx} className="flex items-start space-x-3">
                              <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                              <span className="text-gray-700">{feature}</span>
                            </li>
                          ))}
                        </ul>
                        
                        <Link
                          to="/contact"
                          className={`block w-full text-center py-3 px-6 rounded-lg font-semibold transition-all duration-200 ${
                            isPopular
                              ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:shadow-lg'
                              : 'bg-gray-100 text-blue-600 hover:bg-blue-600 hover:text-white border-2 border-blue-600'
                          }`}
                        >
                          Demander un devis
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Info Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-blue-200">
            <h3 className="text-2xl font-bold text-white mb-6 text-center bg-blue-600 py-4 px-6 rounded-lg" style={{ fontFamily: 'Times New Roman, serif', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)' }}>
              INFORMATIONS IMPORTANTES
            </h3>
            <div className="space-y-4 text-gray-700">
              <p className="flex items-start space-x-3">
                <span className="text-blue-600 font-bold flex-shrink-0">•</span>
                <span>
                  <strong className="text-lg" style={{ fontFamily: 'Times New Roman, serif' }}>Tarifs indicatifs:</strong> <span className="text-base" style={{ fontFamily: 'Arial, sans-serif' }}>Les prix affichés sont à titre indicatif. Le coût final dépendra de la complexité de votre dossier.</span>
                </span>
              </p>
              <p className="flex items-start space-x-3">
                <span className="text-blue-600 font-bold flex-shrink-0">•</span>
                <span>
                  <strong className="text-lg" style={{ fontFamily: 'Times New Roman, serif' }}>Soumission gratuite:</strong> <span className="text-base" style={{ fontFamily: 'Arial, sans-serif' }}>Nous offrons une évaluation gratuite de vos besoins pour vous fournir un devis précis.</span>
                </span>
              </p>
              <p className="flex items-start space-x-3">
                <span className="text-blue-600 font-bold flex-shrink-0">•</span>
                <span>
                  <strong className="text-lg" style={{ fontFamily: 'Times New Roman, serif' }}>Forfaits personnalisés:</strong> <span className="text-base" style={{ fontFamily: 'Arial, sans-serif' }}>Nous pouvons créer des forfaits sur mesure selon vos besoins spécifiques.</span>
                </span>
              </p>
              <p className="flex items-start space-x-3">
                <span className="text-blue-600 font-bold flex-shrink-0">•</span>
                <span>
                  <strong className="text-lg" style={{ fontFamily: 'Times New Roman, serif' }}>Rabais disponibles:</strong> <span className="text-base" style={{ fontFamily: 'Arial, sans-serif' }}>Rabais pour nouveaux clients et forfaits multiples services.</span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Des questions sur nos tarifs?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Contactez-nous pour obtenir une soumission personnalisée adaptée à vos besoins
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-blue-600 bg-white rounded-lg hover:bg-gray-100 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            Obtenir une soumission gratuite
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Tarifs;
